var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM9 1.63636C13.0668 1.63636 16.3636 4.93318 16.3636 9C16.3636 13.0668 13.0668 16.3636 9 16.3636C4.93318 16.3636 1.63636 13.0668 1.63636 9C1.63636 4.93318 4.93318 1.63636 9 1.63636Z",
    fill: "#78264F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6879 6.13153L3.70813 6.7972L3.6137 6.82403C3.0668 7.01439 2.879 7.7184 3.29021 8.156L5.56454 10.5759L5.03446 13.5185L5.02327 13.6052C4.97453 14.2338 5.64623 14.6926 6.22318 14.3864L8.99927 12.9126L11.7768 14.3864L11.8559 14.4235C12.4398 14.6614 13.0814 14.1613 12.9655 13.5186L12.4348 10.5759L14.71 8.156L14.773 8.08073C15.1184 7.61594 14.8781 6.92807 14.292 6.7972L11.3114 6.13153L9.7032 3.42715C9.386 2.89407 8.61413 2.89408 8.29694 3.42716L6.6879 6.13153ZM9.00008 5.44507L10.0867 7.27183L10.1405 7.35126C10.2567 7.50286 10.4231 7.6099 10.6115 7.65197L12.5346 8.08125L10.9607 9.75631L10.8989 9.83037C10.7658 10.0104 10.7115 10.2387 10.7517 10.4618L11.0562 12.1509L9.38362 11.2639L9.29163 11.2221C9.07267 11.1386 8.82642 11.1525 8.61655 11.2638L6.94318 12.1509L7.24846 10.4618L7.25996 10.366C7.2735 10.1425 7.19476 9.92153 7.03951 9.75631L5.46472 8.08125L7.38863 7.65197C7.60843 7.60289 7.79828 7.46537 7.91344 7.27183L9.00008 5.44507Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAward);
export default __webpack_public_path__ + "static/media/red-award.cccc05c5.svg";
export { ForwardRef as ReactComponent };